// Homepage 2026 (new_design_hp_2026) — interactions scoped to .homepage-2026.
// Ported from the ENG-7528 mockup: scroll-reveal, browse toggle (Family/Category),
// scroll dots (mobile) and scroll arrows (desktop). The mockup's nav-scroll is
// omitted on purpose: the header is provided by the theme.
(function () {
  const root = document.querySelector('.homepage-2026');
  if (!root) return;

  // ── Scroll Reveal ──
  const STAGGER_SEL = '.product-card, .product-card-dk, .testimonial-card, .mood-tile, .match-card, .cat-tile';

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const children = el.querySelectorAll(STAGGER_SEL);

      if (children.length > 0) {
        // Container reveal — animate itself immediately, stagger children
        el.style.opacity = '1';
        el.style.transform = 'none';
        children.forEach((child, idx) => {
          child.style.opacity = '0';
          child.style.transform = 'translateY(14px)';
          child.style.transition = 'opacity 400ms ease-out, transform 400ms ease-out';
          child.style.transitionDelay = Math.min(idx, 7) * 70 + 'ms';
          // Double rAF: first commits initial state, second triggers the transition
          requestAnimationFrame(() => requestAnimationFrame(() => {
            child.style.opacity = '1';
            child.style.transform = 'translateY(0)';
          }));
        });
      } else {
        // Leaf element — animate itself
        el.classList.add('visible');
      }

      revealObserver.unobserve(el);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

  root.querySelectorAll('.reveal').forEach((el) => {
    // Scroll tracks must stay visible so overflow works — only their children stagger
    if (el.id === 'mood-track' || el.id === 'products-track' || el.id === 'cat-track') {
      el.style.opacity = '1';
      el.style.transform = 'none';
    }
    revealObserver.observe(el);
  });

  // ── Scroll dot indicators (mobile only) ──
  let bindBrowseDots = null;
  (function initScrollDots() {
    // Resolve the measurable element for each track child. The products carousel
    // wraps cards in <product-card> custom elements styled `display: contents`,
    // which generate no box (offsetWidth === 0). Looking through the wrapper to
    // the inner .product-card keeps the dot count correct for both carousels.
    function getItems(track) {
      return Array.from(track.children).reduce((acc, child) => {
        let el = child;
        if (el.offsetWidth === 0) {
          el = el.querySelector('.product-card, .product-card-dk') || el;
        }
        if (el.offsetWidth > 0) acc.push(el);
        return acc;
      }, []);
    }

    function buildDots(dotsEl, track) {
      if (!dotsEl || !track) return;
      const items = getItems(track);
      dotsEl.innerHTML = '';
      items.forEach((item, i) => {
        const dot = document.createElement('button');
        dot.className = 'scroll-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', `Go to item ${i + 1}`);
        dot.addEventListener('click', () => {
          track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsEl.appendChild(dot);
      });
    }

    function updateActive(dotsEl, track) {
      if (!dotsEl || !track) return;
      const dots = dotsEl.querySelectorAll('.scroll-dot');
      const items = getItems(track);
      if (!items.length) return;
      const scrollLeft = track.scrollLeft;
      let closest = 0;
      let minDist = Infinity;
      items.forEach((item, i) => {
        const dist = Math.abs(item.offsetLeft - track.offsetLeft - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      dots.forEach((d, i) => d.classList.toggle('active', i === closest));
    }

    // Attach the scroll listener once per track. Hidden tracks (display:none)
    // don't scroll, so binding both browse tracks up-front is safe.
    function bindScroll(dotsEl, track) {
      let raf = null;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { updateActive(dotsEl, track); raf = null; });
      }, { passive: true });
    }

    // Products carousel
    const productsTrack = root.querySelector('#products-track');
    const productsDots = root.querySelector('[data-dots-for="products-track"]');
    if (productsTrack && productsDots) {
      buildDots(productsDots, productsTrack);
      bindScroll(productsDots, productsTrack);
    }

    // Browse carousel (family or category, whichever visible).
    // Scroll listeners bind once per track; tab switches only rebuild the dots
    // for the now-visible track (avoids accumulating listeners on each toggle).
    const browseDots = root.querySelector('[data-dots-for="browse-active"]');
    const familyTrack = root.querySelector('#mood-track');
    const categoryTrack = root.querySelector('#cat-track');
    if (browseDots) {
      [familyTrack, categoryTrack].forEach((t) => { if (t) bindScroll(browseDots, t); });
    }
    bindBrowseDots = function (track) {
      if (!browseDots || !track) return;
      buildDots(browseDots, track);
    };
    // Initial build for the visible track
    if (categoryTrack) bindBrowseDots(categoryTrack);
  })();

  // ── Desktop scroll arrows ──
  let syncBrowseArrows = null;
  (function initScrollArrows() {
    function getTrack(targetAttr) {
      if (targetAttr === 'browse-active') {
        const family = root.querySelector('#mood-track');
        const cat = root.querySelector('#cat-track');
        if (family && family.style.display !== 'none') return family;
        return cat;
      }
      return root.querySelector('#' + targetAttr);
    }

    function getStep(track) {
      const first = track.children[0];
      if (!first) return 300;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateArrowState(arrow, track) {
      const direction = arrow.dataset.scrollArrow;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (direction === 'prev') arrow.disabled = track.scrollLeft <= 2;
      else arrow.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function bindArrow(arrow) {
      arrow.addEventListener('click', () => {
        const track = getTrack(arrow.dataset.scrollTarget);
        if (!track) return;
        const step = getStep(track);
        const direction = arrow.dataset.scrollArrow === 'prev' ? -1 : 1;
        track.scrollBy({ left: step * direction, behavior: 'smooth' });
      });
    }

    // Attach the scroll listener once per track (rAF-throttled).
    function onTrackScroll(track, syncFn) {
      let raf = null;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { syncFn(); raf = null; });
      }, { passive: true });
    }

    // Initialize all arrows
    root.querySelectorAll('.scroll-arrow').forEach(bindArrow);

    // Wire products arrows to products track (static track)
    const productsArrows = Array.from(root.querySelectorAll('[data-scroll-target="products-track"]'));
    const productsTrack = root.querySelector('#products-track');
    if (productsTrack && productsArrows.length) {
      const syncProducts = () => productsArrows.forEach((a) => updateArrowState(a, productsTrack));
      syncProducts();
      onTrackScroll(productsTrack, syncProducts);
      window.addEventListener('resize', syncProducts);
    }

    // Wire browse arrows — bind scroll/resize once per track; tab switches only
    // re-run the sync against the active track (avoids accumulating listeners).
    const browseArrows = Array.from(root.querySelectorAll('[data-scroll-target="browse-active"]'));
    const familyTrack = root.querySelector('#mood-track');
    const categoryTrack = root.querySelector('#cat-track');
    if (browseArrows.length && (familyTrack || categoryTrack)) {
      let activeBrowseTrack = categoryTrack;
      const syncBrowse = () => {
        if (activeBrowseTrack) browseArrows.forEach((a) => updateArrowState(a, activeBrowseTrack));
      };
      [familyTrack, categoryTrack].forEach((t) => { if (t) onTrackScroll(t, syncBrowse); });
      window.addEventListener('resize', syncBrowse);
      syncBrowseArrows = function (track) {
        activeBrowseTrack = track;
        syncBrowse();
      };
      syncBrowse();
    }
  })();

  // ── Browse toggle (Family / Category) ──
  (function initBrowseToggle() {
    const tabFamily = root.querySelector('#browse-tab-family');
    const tabCategory = root.querySelector('#browse-tab-category');
    const familyTrack = root.querySelector('#mood-track');
    const categoryTrack = root.querySelector('#cat-track');
    if (!tabFamily || !tabCategory || !familyTrack || !categoryTrack) return;

    function selectMode(target) {
      const isFamily = target === 'family';
      tabFamily.classList.toggle('active', isFamily);
      tabCategory.classList.toggle('active', !isFamily);
      tabFamily.setAttribute('aria-selected', isFamily ? 'true' : 'false');
      tabCategory.setAttribute('aria-selected', isFamily ? 'false' : 'true');
      familyTrack.style.display = isFamily ? 'flex' : 'none';
      categoryTrack.style.display = isFamily ? 'none' : 'flex';
      // Re-bind dots and arrows to the visible track
      if (bindBrowseDots) bindBrowseDots(isFamily ? familyTrack : categoryTrack);
      if (syncBrowseArrows) syncBrowseArrows(isFamily ? familyTrack : categoryTrack);
    }
    tabFamily.addEventListener('click', () => selectMode('family'));
    tabCategory.addEventListener('click', () => selectMode('category'));
  })();

  // ── Yotpo bottomLine post-process + badge width ──
  // Ported from sections/main-collection-horizontal-pills.liquid:230-324, scoped
  // to .homepage-2026. The reskin component's cards/drawers emit
  // <div class="yotpo bottomLine"> that Yotpo hydrates as "198 Reviews"; we
  // reformat it to "(198)" in .pc-review-count (cards) and "4.6 (198 reviews)"
  // in .qa-review-text (drawer). Yotpo's own text is hidden via CSS.
  (function initReviewPostProcess() {
    const extractReviewStats = (widget) => {
      const text = (widget.textContent || '').trim();
      if (!text) return null;
      const countMatch = text.match(/(\d[\d,]*)\s*reviews?\b/i) || text.match(/\((\d[\d,]*)\)/);
      const ratingMatch = text.match(/\b(\d(?:\.\d+)?)\s*(?:out\s*of|\/|\s+\()/i)
        || text.match(/^(\d\.\d+)\b/);
      if (!countMatch) return null;
      return {
        count: countMatch[1].replace(/,/g, ''),
        rating: ratingMatch ? ratingMatch[1] : null,
      };
    };
    const applyReviewStats = (widget) => {
      const stats = extractReviewStats(widget);
      if (!stats) return false;
      const wrapper = widget.parentElement;
      if (!wrapper) return false;
      if (wrapper.classList.contains('pc-review')) {
        const el = wrapper.querySelector('[data-review-count-display]');
        if (el) el.textContent = '(' + stats.count + ')';
        return true;
      }
      if (wrapper.classList.contains('qa-review')) {
        const el = wrapper.querySelector('[data-review-summary-display]');
        if (el) {
          el.textContent = (stats.rating ? stats.rating + ' ' : '')
            + '(' + stats.count + ' reviews)';
        }
        return true;
      }
      return false;
    };
    root.querySelectorAll('.yotpo.bottomLine').forEach((widget) => {
      if (applyReviewStats(widget)) return;
      const obs = new MutationObserver(() => {
        if (applyReviewStats(widget)) obs.disconnect();
      });
      obs.observe(widget, { childList: true, subtree: true, characterData: true });
    });
  })();

  // ── Badge width (--badge-w) ──
  // The rotated badge (.card__badge.top) uses `top: calc(var(--badge-w,108px)+1.1rem)`
  // to keep its visual top edge 1.1rem from the top of the image regardless of
  // how many tags / how long the text is. We measure offsetWidth (unaffected
  // by the rotate) and write it into --badge-w.
  (function initBadgeWidth() {
    const updateBadgeWidth = (badge) => {
      const w = badge.offsetWidth;
      if (w > 0) badge.style.setProperty('--badge-w', w + 'px');
    };
    const updateAllBadges = () => {
      root.querySelectorAll('.pc-img .card__badge').forEach(updateBadgeWidth);
    };
    updateAllBadges();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateAllBadges);
    }
    let badgeRaf = null;
    window.addEventListener('resize', () => {
      if (badgeRaf) return;
      badgeRaf = requestAnimationFrame(() => {
        updateAllBadges();
        badgeRaf = null;
      });
    }, { passive: true });
  })();
})();
